export interface IRegion {
    id: number
    name: string
    created_at: string
    updated_at: string
    deleted_at: string | null
    cities: string | null
    zips: string[]
    customer_area_id: string
    recurly_id: string | null
}

export class Region {
    private id: number = 0
    private name: string = ''
    private created_at: string = ''
    private updated_at: string = ''
    private deleted_at: string | null = null
    private cities: string | null = null
    private zips: string[] = []
    private customer_area_id: string = ''
    private recurly_id: string | null = null

    constructor(o: IRegion | undefined) {
        if (o !== undefined) {
            this.id = o.id
            this.name = o.name
            this.created_at = o.created_at
            this.updated_at = o.updated_at
            this.deleted_at = o.deleted_at
            this.cities = o.cities
            this.zips = o.zips
            this.customer_area_id = o.customer_area_id
            this.recurly_id = o.recurly_id
        }
    }
    public get Id(): number {
        return this.id
    }   
    public get Name(): string {
        return this.name
    }
    public get CreatedAt(): string {
        return this.created_at
    }
    public get UpdatedAt(): string {
        return this.updated_at
    }
    public get DeletedAt(): string | null {
        return this.deleted_at
    }
    public get Cities(): string | null {
        return this.cities
    }
    public get Zips(): string[] {
        return this.zips
    }
    public get CustomerAreaId(): string {
        return this.customer_area_id
    }
    public get RecurlyId(): string | null {
        return this.recurly_id
    }
    public set Name(name: string) {
        this.name = name
    }
    public set CreatedAt(created_at: string) {
        this.created_at = created_at
    }
    public set UpdatedAt(updated_at: string) {
        this.updated_at = updated_at
    }
    public set DeletedAt(deleted_at: string | null) {
        this.deleted_at = deleted_at
    }
    public set Cities(cities: string | null) {
        this.cities = cities
    }
    public set Zips(zips: string[]) {
        this.zips = zips
    }
    public set CustomerAreaId(customer_area_id: string) {
        this.customer_area_id = customer_area_id
    }
    public set RecurlyId(recurly_id: string | null) {
        this.recurly_id = recurly_id
    }
    public set Id(id: number) {
        this.id = id
    }
}